import { X } from "lucide-react";
import { ICONS, ICON_KEYS } from "@/lib/icons";

export const inputCls =
  "w-full rounded-xl border border-line bg-white px-3.5 py-2.5 text-sm text-ink transition focus:border-gold focus:outline-none";

export function Card({ title, children, testid }) {
  return (
    <section className="rounded-2xl border border-line bg-cream p-6 shadow-sm" data-testid={testid}>
      <h3 className="font-head text-base font-extrabold text-forest-900">{title}</h3>
      <div className="mt-5 space-y-4">{children}</div>
    </section>
  );
}

export function Field({ label, children }) {
  return (
    <label className="block">
      <span className="mb-1.5 block text-xs font-semibold text-moss">{label}</span>
      {children}
    </label>
  );
}

export function StringList({ items, onChange, addLabel = "+ إضافة عنصر" }) {
  if (!items) return null;
  return (
    <div className="space-y-2">
      {items.map((s, i) => (
        <div key={i} className="flex gap-2">
          <input
            className={inputCls}
            value={s}
            data-testid={`string-list-input-${i}`}
            onChange={(e) => {
              const c = [...items];
              c[i] = e.target.value;
              onChange(c);
            }}
          />
          <button
            type="button"
            onClick={() => onChange(items.filter((_, j) => j !== i))}
            data-testid={`string-list-remove-${i}`}
            aria-label="حذف"
            className="shrink-0 rounded-xl border border-line px-3 text-moss transition hover:border-brick hover:text-brick"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      ))}
      <button
        type="button"
        onClick={() => onChange([...items, ""])}
        data-testid="string-list-add"
        className="rounded-xl border border-dashed border-gold px-4 py-2 text-xs font-bold text-gold-dark transition hover:bg-gold/10"
      >
        {addLabel}
      </button>
    </div>
  );
}

export function IconSelect({ value, onChange }) {
  const Icon = ICONS[value] || ICONS.star;
  return (
    <div className="flex items-center gap-2">
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gold/15 text-gold-dark">
        <Icon className="h-5 w-5" />
      </span>
      <select value={value} onChange={(e) => onChange(e.target.value)} className={inputCls} data-testid="icon-select">
        {ICON_KEYS.map((k) => (
          <option key={k} value={k}>
            {k}
          </option>
        ))}
      </select>
    </div>
  );
}
